import { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import { X } from 'lucide-react';

export default function AgentDialog({ title, onClose, children, busy = false }) {
  const dialog = useRef(null), close = useRef(onClose);
  close.current = onClose;
  useEffect(() => {
    const previous = document.activeElement;
    const elements = () => [...dialog.current.querySelectorAll('button:not(:disabled),input:not(:disabled),select:not(:disabled),textarea,a[href]')];
    elements()[0]?.focus();
    function keydown(event) {
      if (event.key === 'Escape' && !busy) { event.preventDefault(); close.current(); }
      if (event.key !== 'Tab') return;
      const controls = elements(), first = controls[0], last = controls[controls.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
    }
    document.addEventListener('keydown', keydown);
    return () => { document.removeEventListener('keydown', keydown); if (previous?.isConnected) previous.focus(); };
  }, [busy]);
  return createPortal(<div className="av2-dialog-backdrop" onClick={e => e.stopPropagation()}>
    <section ref={dialog} className="av2-dialog" role="dialog" aria-modal="true" aria-label={title}>
      <header><h2>{title}</h2><button className="av2-icon-button" aria-label="Dialog schließen" disabled={busy} onClick={onClose}><X size={19}/></button></header>
      {children}
    </section>
  </div>, document.body);
}
